import React, { lazy, useEffect } from 'react';
import { filterList, filterWithDateRange } from 'globalutils/fmUtils';
import { fields } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const FilterLogsListForm = ({ values, udLogList, handleClear, udFilterSuccess, setValues, i18n, setPagination }) => {
  const formId = 'filterUdLogsListForm';

  useEffect(() => {
    if (values && Object.keys(values).length > 0) {
      handleFilter();
    }
  }, [JSON.stringify(udLogList?.filteredList)]);

  const handleFilter = () => {
    const filters = values;
    Object.keys(filters).map((key) => filters[key] === null || (filters[key] === '' && delete filters[key]));
    let result = filters?.driver_name ? filterList(udLogList.list, 'driver_name', values.driver_name) : udLogList.list;
    if (filters?.dateFrom || filters?.dateTo) {
      result = filterWithDateRange(result, filters?.dateFrom, filters?.dateTo);
    }

    udFilterSuccess(result);
    setPagination(true);
  };

  const handleCancel = () => {
    setValues({
      driver_name: 'Unidentified Driver',
      dateFrom: '',
      dateTo: '',
    });
    udFilterSuccess(udLogList.list);
    setPagination(true);
    handleClear();
  };

  return (
    <Form
      id={formId}
      direction="row"
      type="client"
      values={{ ...values }}
      className="filterForm"
      handleOnSubmit={() => {
        handleFilter();
        handleClear();
      }}
      handleOnCancel={handleCancel}
      setValues={setValues}
      fields={fields}
    />
  );
};

export default FilterLogsListForm;
